import React, { useEffect, useRef, useState } from "react";
import style from "./style.module.css";

function index({ index, imgLen }) {
  const [array, setArray] = useState([...Array(imgLen)]);

  const ref = useRef(null);

  const handleScroll = () => {
    const maxScrollLeft = ref.current.scrollWidth - ref.current.clientWidth;
    if (index >= 3 && index <= imgLen - 3)
      ref.current.scrollLeft = (index - 1) * 9 - 7;
    if (index < 3) ref.current.scrollLeft = 0;
    if (index > imgLen - 3) ref.current.scrollLeft = maxScrollLeft;
  };

  useEffect(() => {
    handleScroll();
  }, [index]);
  return (
    <div
      className={style.dotsContainer}
      style={{ width: `calc(${9 * 5.5}px)` }}
      ref={ref}
    >
      {array.map((item, key) => {
        return (
          <div
            key={key}
            className={`${
              index - 1 === key ? style.activeDot : style.dotWidth7
            } ${
              index === key
                ? style.dotWidth7
                : index + 1 === key
                ? style.dotWidth6
                : index + 2 === key
                ? style.dotWidth5
                : index + 2 < key
                ? style.dotWidth4
                : null
            } ${
              key === index - 2
                ? style.dotWidth7
                : key === index - 3
                ? style.dotWidth6
                : key === index - 4
                ? style.dotWidth5
                : key < index - 4
                ? style.dotWidth4
                : null
            }`}
          ></div>
        );
      })}
    </div>
  );
}

export default index;
